module.exports = __webpack_public_path__ + "img/zixun-bottom.afb8e11.png";